module.exports = __webpack_public_path__ + "static/red-60596a450ca4b5bd09ac14e0b9720160.jpg";